import { BodyTypes } from '../../LevelManager';
import { LevelFeature } from './../LevelFeature';
import { RingPart } from './RingPart';

export class RingFeature extends Phaser.GameObjects.GameObject implements LevelFeature {
  public  scene: Phaser.Scene;
  protected layer: Phaser.GameObjects.Layer;
  protected x: number;
  protected y: number;
  protected rampEntranceWidth: number;
  protected ringBack: RingPart;
  protected ringFront: RingPart;

  constructor(scene: Phaser.Scene, layer: Phaser.GameObjects.Layer, x: number, y: number) {
    super(scene, 'ringFeature');

    this.scene = scene;
    this.layer = layer;
    this.x = x;
    this.y = y;

    this.rampEntranceWidth = 160;

    this.ringBack = new RingPart(this.scene, x, y, 'game-sky', 'sky-hoop-back.png');
    this.ringBack.scaleX = this.ringBack.scaleY = 0.7;
    this.ringBack.setDepth(this.getRampEntry() - this.rampEntranceWidth * 0.5);
    this.layer.add(this.ringBack);
    this.ringFront = new RingPart(this.scene, x, y, 'game-sky', 'sky-hoop-front.png');
    this.ringFront.scaleX = this.ringFront.scaleY = 0.7;
    this.ringFront.setDepth(this.getRampEntry() + this.rampEntranceWidth * 0.5);
    this.layer.add(this.ringFront);
  }

  public init() {
    let x = this.x;
    let y = this.y;

    let rect: MatterJS.BodyType = this.scene.matter.bodies.rectangle(this.ringBack.x, this.ringBack.y + 40, this.ringBack.displayWidth, this.rampEntranceWidth, {
      label: BodyTypes.Ramp,
      isSensor: true,
      isStatic: true
    });
    // rect.position.y -= this.spawnOffsetY;
    rect.position.y += -40;

    let matterSprite = this.scene.matter.add.gameObject(this, rect) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(this.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(this.body as MatterJS.BodyType, 0, 0);
  }

  public isRing(): boolean {
    return true;
  }

  public getRampEntry(): number {
    // return this.y + this.spawnOffsetY + this.rampEntranceWidth * 0.5;
    return this.y + this.rampEntranceWidth * 0.5;
  }

  public getBlockZone(): Phaser.Geom.Rectangle {
    // return new Phaser.Geom.Rectangle(this.x - this.displayOriginX, this.y + this.spawnOffsetY, this.width, this.rampEntranceWidth);
    return new Phaser.Geom.Rectangle(this.ringBack.x - this.ringBack.displayOriginX, this.ringBack.y, this.ringBack.width, this.rampEntranceWidth);
    // return new Phaser.Geom.Rectangle(0, 0, 0, 0);
  }
}
